// Thin client for the existing /api/v1/sessions endpoints. Mirrors what
// NYNotary_ios/NYNotary/APIService.swift does. The web build is served from
// the same origin as the API, so we use a relative base URL.

const BASE_URL = "/api/v1";

export interface CreateSessionResult {
  id: number;
  token: string;
  status: string;
}

function csrfToken(): string {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
  return meta?.content ?? "";
}

export async function createSession(input: {
  name: string;
  phone: string;
  email: string;
}): Promise<CreateSessionResult> {
  const res = await fetch(`${BASE_URL}/sessions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    body: JSON.stringify({ session: input }),
  });

  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(`Could not create session (HTTP ${res.status}): ${body}`);
  }

  return res.json();
}

export async function uploadDocuments(args: {
  sessionId: number;
  token: string;
  files: File[];
}): Promise<void> {
  const fd = new FormData();
  for (const file of args.files) {
    fd.append("documents[]", file, file.name);
  }

  const res = await fetch(`${BASE_URL}/sessions/${args.sessionId}/add_documents`, {
    method: "POST",
    headers: {
      "X-Session-Token": args.token,
      "X-CSRF-Token": csrfToken(),
    },
    body: fd,
  });

  if (!res.ok) {
    throw new Error(`Document upload failed (HTTP ${res.status})`);
  }
}

export async function confirmSession(args: {
  sessionId: number;
  token: string;
}): Promise<void> {
  const res = await fetch(`${BASE_URL}/sessions/${args.sessionId}/confirm`, {
    method: "POST",
    headers: {
      "X-Session-Token": args.token,
      "Accept": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
  });

  if (!res.ok) {
    throw new Error(`Confirm failed (HTTP ${res.status})`);
  }
}
